import { WINDOW } from '@app/lib/services/window.service';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-unavailable',
  template: '<h1 class="text-center"><i class="fas fa-exclamation-triangle text-danger"></i><span>An error occurred retrieving data. Please try again later.</span></h1>',
  styleUrls: ['./unavailable.component.scss']
})
export class UnavailableComponent implements OnInit, OnDestroy {

  constructor(

    @Inject(WINDOW)
    private readonly window: Window,

    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(this.window.document.body, 'layout-unavailable');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.window.document.body, 'layout-unavailable');
  }
}
